<template>
  <div
    v-if="showActions"
    class="d-inline-flex align-center ga-2"
  >
    <FavouriteBtn
      v-ripple
      :class="roundedClass"
      type="doctors"
      :size="size"
      :target-id="doctorId"
    />
    <ShareBtn
      v-ripple
      :class="roundedClass"
      type="doctor"
      url-name="doctor"
      :size="size"
      :url="doctorPageUrl"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useContextStore from 'src/store/useContextStore'
import type { CommonContextStore } from 'src/types/context'
import FavouriteBtn from 'src/components/common/FavouriteBtn/FavouriteBtn.vue'
import ShareBtn from 'src/components/common/ShareBtn/ShareBtn.vue'

withDefaults(defineProps<{
  doctorId: number
  doctorPageUrl: string
  size: number
  roundedClass?: string
}>(), {
  roundedClass: '',
})

const { context }: CommonContextStore = useContextStore()

/**
 * Избранное и шаринг доступны анонимам и пациентам.
 * У staff / врача / клиники без patient_profile кнопок нет.
 */
const showActions = computed(() => (
  Boolean(context.request.user?.patient_profile)
  || !context.request.user.is_authenticated
))
</script>
